/* Bait Dogs — scroll reveal. Ported from design-reference/site.js initReveal().
   Adds .in to .reveal elements as they enter the viewport. Without this the
   .reveal { opacity: 0 } rule in bait-dogs.css leaves sections invisible. */
(function () {
  "use strict";

  function revealAll(root) {
    (root || document).querySelectorAll(".reveal:not(.in)").forEach(function (el) {
      el.classList.add("in");
    });
  }

  function observe(root) {
    var els = (root || document).querySelectorAll(".reveal:not(.in)");
    if (!els.length) return;
    if (!("IntersectionObserver" in window)) { revealAll(root); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  function fixAreaLinks(root) {
    var links = {
      "chicago": "/pages/streetwear-chicago",
      "los angeles": "/pages/streetwear-los-angeles",
      "new york": "/pages/streetwear-new-york",
      "houston": "/pages/streetwear-houston"
    };

    (root || document).querySelectorAll(".areas-strip .area-card").forEach(function (card) {
      var city = card.querySelector("h3");
      if (!city) return;
      var href = links[city.textContent.trim().toLowerCase()];
      if (href) card.setAttribute("href", href);
    });
  }

  function init() {
    observe(document);
    fixAreaLinks(document);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // Shopify theme editor: reveal sections re-rendered after a settings change.
  document.addEventListener("shopify:section:load", function (e) {
    observe(e.target);
    fixAreaLinks(e.target);
  });

  // Failsafe: never leave on-screen content hidden if the observer doesn't fire.
  window.addEventListener("load", function () {
    setTimeout(function () {
      document.querySelectorAll(".reveal:not(.in)").forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add("in");
      });
    }, 500);
  });
})();
